import {getApiItem, postApiItem, updateApiItem} from "@/api/backend";
import useAsyncStore from '@/composables/useAsyncWrapper'

const { useState, useActions, useMutations } = useAsyncStore
const { postItem, patchItem, fetchItem } = useActions

const initialState = {
  item: {
    id: null,
    discount: 0,
    type: '',
    active: false,
    name: '',
    image: null
  }
}

const state = {
  ...useState,
  ...initialState
}

const mutations = {
  ...useMutations
}

const actions = {
  resetForm(context) {
    context.commit('setItem', initialState.item)
  },
  async handleFetchItem(context, { token, id }) {
    await fetchItem(context, async () => await getApiItem(`/product-tags`, token, id) )
  },
  async handlePostItem(context, { token, data}) {
    await postItem(
      context,
      async () => await postApiItem('/product-tags', token, data),
      'Usługa dodana pomyślnie'
    )
  },
  async handlePatchItem(context, { token, id, data }) {
    await postItem(
      context,
      async () => await updateApiItem(`/product-tags/${id}`, token, data),
      'Usługa zaktualizowana pomyślnie'
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
